import {ICourseOverviewLessonFeatures} from "../../../config/course-overview";

function setLessonTypesLabel(hasNotation?: boolean, hasVideo?: boolean): string {
  if (hasNotation && hasVideo) {
    return 'Video & interactive notation'
  }

  if (hasNotation) {
    return 'Interactive notation'
  }

  if (hasVideo) {
    return 'Video only'
  }

  return '';
}

function setCourseOrganizationIcon(organizationMethod: string): 'icon-order-any' | 'icon-order-sequential' | 'icon-order-difficulty' | 'icon-order-key-signature' {
  if (organizationMethod === 'Sequential order') {
    return 'icon-order-sequential'
  }

  if (organizationMethod === 'Easiest to hardest') {
    return 'icon-order-difficulty'
  }

  if (organizationMethod === 'Key signature') {
    return 'icon-order-key-signature'
  }

  return 'icon-order-any';
}

export interface ICourseSummaryLogic {
  lessonFeaturesLabel: string,
  courseOrgIcon: string,
}

export const useCourseSummaryLogic = ({lessonFeatures, organizationMethod}: {lessonFeatures?: ICourseOverviewLessonFeatures, organizationMethod: string }): ICourseSummaryLogic => {
  const hasNotation = !!lessonFeatures?.hasInteractiveNotation;
  const hasVideo = !!lessonFeatures?.hasVideo;
  const lessonFeaturesLabel = setLessonTypesLabel(hasNotation, hasVideo);
  const courseOrgIcon = setCourseOrganizationIcon(organizationMethod);


  return { lessonFeaturesLabel, courseOrgIcon };
}